import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./style";

const ArrowLeft = ({ children }) => {
	return (
		<div
			className={css`
				${defaultStyle}
			`}
		>
			<i className="icon-arrow-down rotate-left" /> {children}
		</div>
	);
};

export default ArrowLeft;
